import { GetterTree } from "vuex";
import { RootState } from "../types";
import { KarteState } from "./types";

export const getters: GetterTree<KarteState, RootState> = {};
